import { CHANGE_STATE_IN_PROGRESS } from "~/consts/state.consts"

export const changeIsFinished = (state) => {
  return !CHANGE_STATE_IN_PROGRESS.includes(state)
}
